import { DayTypeType } from './day.interface';
import { ReservationTypeTypes } from './reservation.interface';

export interface ListExport {
  id: number;
  uuid: string;
  list_type: ListExportType;
  festival_id: number;
  daytype: DayTypeType;
  date: string;
  only_type?: ReservationTypeTypes;
  filename: string;
}

export type ListExportType =
  | 'default'
  | 'security'
  | 'notice'
  | 'control'
  | 'onlytype'
  | 'daypaylist';
export const ListExportTypeMapper: Record<ListExportType, string> = {
  default: 'Aushang',
  security: 'Security',
  notice: 'Bemerkungen',
  control: 'Kontrolle',
  onlytype: 'Selektion',
  daypaylist: 'Rechnung & Zahlungsart',
};

export interface ListExportParams {
  list_type: ListExportType;
  festival_id: number;
  daytype: DayTypeType;
  date: string;
  only_type?: ReservationTypeTypes;
}
